import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NotFound } from './components/not-found/not-found';
import { NoAccessComponent } from './components/no-access/no-access.component';
import { GlobalSpinnerComponent } from './components/global-spinner/global-spinner.component';
import { NotificationPanelComponent } from './components/notification-panel/notification-panel.component';
import { WikiPanelComponent } from './components/wiki-panel/wiki-panel.component';
import { WikiHelpButtonComponent } from './components/wiki-help-button/wiki-help-button.component';
import { FeatureGuideComponent } from './components/feature-guide/feature-guide.component';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { TableModule } from 'primeng/table';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { TagModule } from 'primeng/tag';
import { ToastModule } from 'primeng/toast';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { MainLayoutComponent } from './layout/main-layout/main-layout.component';
import { TopbarComponent } from './components/topbar/topbar.component';
import { ChatOverlayComponent } from './components/chat-overlay/chat-overlay.component';
import { DividerModule } from 'primeng/divider';
import { SelectModule } from 'primeng/select';
import { ProgressBarModule } from 'primeng/progressbar';
import { ThemePickerComponent } from './components/theme-picker/theme-picker.component';
import { SetupAttentionModalComponent } from './components/setup-attention-modal/setup-attention-modal.component';
import { GuidedTourComponent } from './components/guided-tour/guided-tour.component';
import { TourPromptComponent } from './components/tour-prompt/tour-prompt.component';
import { WikiAttentionModalComponent } from './components/wiki-attention-modal/wiki-attention-modal.component';

const PRIMENG_MODULES = [
    FormsModule, 
    ButtonModule, 
    InputTextModule, 
    PasswordModule, 
    CheckboxModule,
    TableModule,
    TagModule,
    DialogModule,
    ToastModule,
    ConfirmDialogModule,
    PasswordModule,
    DividerModule,
    SelectModule,
    ProgressBarModule
]

const SHARED_COMPONENTS = [
  NotFound,
  NoAccessComponent,
  GlobalSpinnerComponent,
  NotificationPanelComponent,
  WikiPanelComponent,
  SidebarComponent,
  TopbarComponent,
  MainLayoutComponent,
  ChatOverlayComponent,
  SetupAttentionModalComponent,
  GuidedTourComponent,
  TourPromptComponent,
  WikiAttentionModalComponent,
]

@NgModule({
  declarations: [
    ...SHARED_COMPONENTS
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    ThemePickerComponent,
    WikiHelpButtonComponent,
    FeatureGuideComponent,
    ...PRIMENG_MODULES,
  ],
  providers: [
    DatePipe
  ],    
  exports: [
    ...SHARED_COMPONENTS,
    WikiHelpButtonComponent,
    FeatureGuideComponent,
    ...PRIMENG_MODULES,
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
  ]
})
export class SharedModule { }
